<template>
  <div class="account-config page-box">
    <wx-account-selector
      class="wx-select"
    ></wx-account-selector>
    <div class="page-content">
      <el-tabs
        v-model="activeName"
      >
        <el-tab-pane
          label="公众号菜单"
          name="menu"
        >
          <div class="con-tab-ejemplo">
            <account-menu></account-menu>
          </div>
        </el-tab-pane>
       <el-tab-pane
          v-if="isAuth('wx:wxassets:list')"
          name="meterial"
        >
          <div
            slot="label"
            class="label meterial-self-label">
            素材
            <span class="dot">{{ totalMsg }}</span>
          </div>
          <div class="con-tab-ejemplo">
            <material-home
              @send-total-msg="sendTotalMsg"
            ></material-home>
          </div>
        </el-tab-pane>
              <el-tab-pane
                name="airticle"
                label="文章管理"
              >
                <div class="con-tab-ejemplo">
                  <article-manage></article-manage>
                </div>
              </el-tab-pane>
         <el-tab-pane
           name="message"
           label="自动回复规则"
         >
           <div class="con-tab-ejemplo">
             <msgReplyRule></msgReplyRule>
           </div>
         </el-tab-pane>
         <el-tab-pane
           name="tplMsg"
           label="模板消息"
         >
           <div class="con-tab-ejemplo">
             <msg-template></msg-template>
           </div>
         </el-tab-pane>
        <el-tab-pane
           name="paramsQrCode"
           label="带参数二维码"
         >
           <div class="con-tab-ejemplo">
             <wx-qrcode></wx-qrcode>
           </div>
         </el-tab-pane>
        <el-tab-pane
          name="fansManage"
          label="粉丝管理"
        >
          <div class="con-tab-ejemplo">
            <wx-fans></wx-fans>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="publicAccountMsg"
          label="公众号消息"
        >
          <div class="con-tab-ejemplo">
            <wx-msg></wx-msg>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import wxMsg from '../wx-msg/index'
import wxFans from '../wx-user/index'
import wxQrcode from '../wx-qrcode/index'
import wxAccountSelector from '@/components/common/wxAccountSelector'
import msgTemplate from '../msg-template/index'
import msgReplyRule from '../msg-reply-rule/index'
import articleManage from '../article/index'
import materialHome from './materialHome/index'
import accountMenu from '../wx-menu/index'

export default {
  name: "accountConfig",
  components: {
    accountMenu,
    materialHome,
    articleManage,
    msgReplyRule,
    msgTemplate,
    wxAccountSelector,
    wxQrcode,
    wxFans,
    wxMsg,
  },
  data() {
    return {
      totalMsg: 0,
      activeName: 'menu',
      selfBotId: 0,
      material: 1,
    }
  },
  created() {
  },


  mounted(){

    // if(window.screen.width <= 768){
    //   setTimeout(() => {
    //     const viewWidth = document.querySelector(".page-content").offsetWidth - 200;
    //     // 获取所有具有指定类名的元素
    //     const elements = document.querySelectorAll('.el-tabs__item');


    //     // 遍历这些元素并设置宽度
    //     elements.forEach(element => {                                                                                                           
    //         element.style.width = viewWidth + "px"; // 设置宽度为200像素
    //     });

    //     document.querySelector('.el-tabs__nav').style.transform = "translateX(0px)";
    //     document.querySelector('.el-tabs__active-bar').style.width = viewWidth + "px";
        
           
    //     }, 200);
    // }
    
    
  },


  methods: {
    materialChange(val) {

    },
    toQuery(botId) {
      this.selfBotId = botId;
    },
    sendTotalMsg(totalMsg) {
      this.totalMsg = totalMsg;
    },
  },
}
</script>

<style lang="scss" scoped>

.account-config {
  position: relative;

  .con-tab-ejemplo {
  }

  .page-content {

  }


}
// pc端
@media screen and (min-width: 768px) {
  .page-box {
    position: relative;
  }
  .wx-select {
    position: absolute;
    z-index: 99;
    right: 10px;
    top: 15px;
  }
}

//移动端
@media screen and (max-width: 768px) {
  .wx-select {
    width: 100%;
    margin-bottom: 10px;
  }
  .el-tabs__nav-next, .el-tabs__nav-prev {
    line-height: 60px;
  }
}
</style>
<style lang="scss">
@import "../../../assets/scss/variable";

.account-config {
  .el-tabs__item {
    height: 60px;
    line-height: 60px;
  }

  // .el-tabs__nav-scroll {
  //   padding-left: 20px;
  // }
}

.meterial-self-label {
  display: flex;
  justify-content: center;
  align-items: center;

  .dot {
    width: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: $themeColor;
    background-color: #F5F5F5;
    margin-left: 10px;
  }

}
</style>
